import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useParameterGroundBoreholeCreateMutation, useParameterGroundBoreholeDeleteMutation, useParameterGroundBoreholeFindAllQuery, useParameterGroundBoreholeUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import boreholeSvg from "../../../assets/images/svg/borehole.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";

const BoreholeParameter = ({ setBoreholeParameterId }: any) => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useParameterGroundBoreholeFindAllQuery(`?groundwater_id=${id}`);
  const [parameterBoreholeCreate, parameterBoreholeCreateResult] = useParameterGroundBoreholeCreateMutation();
  const [parameterBoreholeUpdate, parameterBoreholeUpdateResult] = useParameterGroundBoreholeUpdateMutation();
  const [parameterBoreholeDelete, parameterBoreholeDeleteResult] = useParameterGroundBoreholeDeleteMutation();

  const [measurementGroundWater, setMeasurementGroundWater] = useState<any>();

  const [is_used, setIs_usedBoolean] = useState<boolean>(false);


  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  const {
    data: qualityData,
    error: qualityDataError,
    isFetching: isQualityDataFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_hydrogeological_quality`);

  useEffect(() => {

    if (measurementGroundWater === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    setMeasurementList(data?.data);
    setMeaCount(measurementList?.length);
    const tempIs_used = measurementGroundWater !== null ? measurementGroundWater?.is_used : false;

    setIs_usedBoolean(tempIs_used)

  }, [measurementGroundWater, qualityData, id, data?.data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementGroundWater?.id,
      groundwater_id: measurementGroundWater?.groundwater_id,
      groundwater_code: measurementGroundWater?.groundwater_code,
      measure_date: measurementGroundWater?.measure_date,
      borehole_code: measurementGroundWater?.borehole_code,
      design: measurementGroundWater?.design,
      depth: measurementGroundWater?.depth,
      cmn_hydrogeological_quality: measurementGroundWater?.cmn_hydrogeological_quality,
      diameter: measurementGroundWater?.diameter,
      refrain: measurementGroundWater?.refrain,
      usage_information: measurementGroundWater?.usage_information,
      water_spurt: measurementGroundWater?.water_spurt,
      water_stable_level: measurementGroundWater?.water_stable_level,
      water_level_decrease: measurementGroundWater?.water_level_decrease,
      water_hydraulic_quality: measurementGroundWater?.water_hydraulic_quality,
      drilling_method_brand: measurementGroundWater?.drilling_method_brand,
    },
    validationSchema: Yup.object({
      groundwater_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_hydrogeological_quality: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      diameter: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      refrain: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_hydraulic_quality: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      drilling_method_brand: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("утга оруулна уу !"),
      borehole_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_spurt: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_stable_level: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_level_decrease: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),


    }),
    onSubmit: (values: any) => {
      if (measurementGroundWater !== null) {
        const updateList = {
          id: measurementGroundWater?.id,
          groundwater_id: measurementGroundWater?.groundwater_id,
          groundwater_code: values.groundwater_code,
          measure_date: values.measure_date,
          borehole_code: values.borehole_code,
          design: values.design,
          depth: values.depth,
          cmn_hydrogeological_quality: values.cmn_hydrogeological_quality,
          diameter: values.diameter,
          refrain: values.refrain,
          usage_information: values.usage_information,
          water_spurt: values.water_spurt,
          water_stable_level: values.water_stable_level,
          water_level_decrease: values.water_level_decrease,
          water_hydraulic_quality: values.water_hydraulic_quality,
          drilling_method_brand: values.drilling_method_brand,
          is_used: is_used === undefined ? false : is_used,
        }
        parameterBoreholeUpdate(updateList);
      } else {
        const newList = {
          groundwater_id: id,
          groundwater_code: values["groundwater_code"],
          measure_date: values["measure_date"],
          borehole_code: values["borehole_code"],
          design: values["design"],
          depth: values["depth"],
          cmn_hydrogeological_quality: values["cmn_hydrogeological_quality"],
          diameter: values["diameter"],
          refrain: values["refrain"],
          usage_information: values["usage_information"],
          water_spurt: values["water_spurt"],
          water_stable_level: values["water_stable_level"],
          water_level_decrease: values["water_level_decrease"],
          water_hydraulic_quality: values["water_hydraulic_quality"],
          drilling_method_brand: values["drilling_method_brand"],
          is_used: is_used === undefined ? false : is_used,
        };

        console.log(newList);

        parameterBoreholeCreate(newList)
      }
      // validation.resetForm();
    },
  });



  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (measurementGroundWater) {
      parameterBoreholeDelete(measurementGroundWater.id);
      setDeleteModal(false);
    }
    setMeasurementGroundWater(null);
    setIs_newCreated(true)
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={boreholeSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label me-3"
              onClick={() => {
                validation.resetForm();
                setMeasurementGroundWater(null);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

            {
              is_newCreated === false && measurementGroundWater !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={measurementGroundWater?.water_level_decrease}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementGroundWater(item)
                            setBoreholeParameterId(item.id)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэлийн дугаар </Label>
                      <Input
                        name="groundwater_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.groundwater_code || ""}
                        invalid={
                          validation.touched.groundwater_code &&
                            validation.errors.groundwater_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.groundwater_code &&
                        validation.errors.groundwater_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.groundwater_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Орон зайн шинж төлөв </Label>
                      <Input
                        name="cmn_hydrogeological_quality"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cmn_hydrogeological_quality || ""}
                        invalid={
                          validation.touched.cmn_hydrogeological_quality &&
                            validation.errors.cmn_hydrogeological_quality
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>
                        {qualityData?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.name}</option>
                        ))}
                      </Input>
                      {validation.touched.cmn_hydrogeological_quality &&
                        validation.errors.cmn_hydrogeological_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cmn_hydrogeological_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цооногийн дугаар </Label>
                      <Input
                        name="borehole_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.borehole_code || ""}
                        invalid={
                          validation.touched.borehole_code &&
                            validation.errors.borehole_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.borehole_code &&
                        validation.errors.borehole_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.borehole_code}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Тогтонги түвшин, м </Label>
                      <Input
                        name="water_stable_level"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_stable_level || ""}
                        invalid={
                          validation.touched.water_stable_level &&
                            validation.errors.water_stable_level
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_stable_level &&
                        validation.errors.water_stable_level ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_stable_level}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_usedBoolean(!is_used);
                        }}
                        checked={is_used}
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цооногийн амсрын диаметр (мм) </Label>
                      <Input
                        name="diameter"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.diameter || ""}
                        invalid={
                          validation.touched.diameter &&
                            validation.errors.diameter
                            ? true
                            : false
                        }
                      />
                      {validation.touched.diameter &&
                        validation.errors.diameter ? (
                        <FormFeedback type="invalid">
                          {validation.errors.diameter}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Шингэн зүйн шинж чанар</Label>
                      <Input
                        name="water_hydraulic_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_hydraulic_quality || ""}
                        invalid={
                          validation.touched.water_hydraulic_quality &&
                            validation.errors.water_hydraulic_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_hydraulic_quality &&
                        validation.errors.water_hydraulic_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_hydraulic_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Өрөмдлөгйин арга ба суурь машины марк </Label>
                      <Input
                        name="drilling_method_brand"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.drilling_method_brand || ""}
                        invalid={
                          validation.touched.drilling_method_brand &&
                            validation.errors.drilling_method_brand
                            ? true
                            : false
                        }
                      />
                      {validation.touched.drilling_method_brand &&
                        validation.errors.drilling_method_brand ? (
                        <FormFeedback type="invalid">
                          {validation.errors.drilling_method_brand}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Түвшний бууралт (м) </Label>
                      <Input
                        name="water_level_decrease"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_level_decrease || ""}
                        invalid={
                          validation.touched.water_level_decrease &&
                            validation.errors.water_level_decrease
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_level_decrease &&
                        validation.errors.water_level_decrease ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_level_decrease}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цооногийн гүн (м) </Label>
                      <Input
                        name="depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.depth || ""}
                        invalid={
                          validation.touched.depth &&
                            validation.errors.depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.depth &&
                        validation.errors.depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Түрлэгийн хэмжээ (м) </Label>
                      <Input
                        name="refrain"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.refrain || ""}
                        invalid={
                          validation.touched.refrain &&
                            validation.errors.refrain
                            ? true
                            : false
                        }
                      />
                      {validation.touched.refrain &&
                        validation.errors.refrain ? (
                        <FormFeedback type="invalid">
                          {validation.errors.refrain}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Загвар </Label>
                      <Input
                        name="design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.design || ""}
                        invalid={
                          validation.touched.design &&
                            validation.errors.design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.design &&
                        validation.errors.design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ундрага (л/сек) </Label>
                      <Input
                        name="water_spurt"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_spurt || ""}
                        invalid={
                          validation.touched.water_spurt &&
                            validation.errors.water_spurt
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_spurt &&
                        validation.errors.water_spurt ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_spurt}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын талаарх мэдээлэл </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={12} className="d-flex justify-content-around mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>

      </Row>

    </>
  )
}

export default BoreholeParameter;